
<div class="service-notice">
    <div class="background" />
    <div class="main">
        <p class="hold">⚠️ Songkran Warning 💦</p>
        <p>Due to Songkran Festival there is a lot of traffic, some roads are completely blocked and many restaurants
            are closed.</p>
        <p class="has-text-weight-bold" style="padding: 12px 0">If your order is successful, delivery will take at
            least twice as long as normal.
        </p>

        <p class="buttons" style="margin: 16px 0">
            <span class="button is-fullwidth is-medium is-warning is-capitalized pulse" @click="close"><i
                    class="fa fa-check-double" />&nbsp;I
                Acknowledge</span>
        </p>
    </div>
</div>
